import React, { FC, ReactNode, memo } from 'react';
import { Appear } from '../appear';
import { Container } from '../container';
import { BRAND_COLORS } from '@montana/constants/colors';

export interface IStaticHeroProps {
    children?: ReactNode;
    backgroundColorHex?: string;
    className?: string;
}

export const StaticHeroComponent: FC<IStaticHeroProps> = memo(({ children, className, backgroundColorHex = BRAND_COLORS.WHITE.color }: IStaticHeroProps) => (
    <section className={`static-hero${className ? ` ${className}` : ''}`}>
        <div className="static-hero__bg" style={{ backgroundColor: backgroundColorHex }}></div>
        <Appear>
            <Container>
                {children}
            </Container>
        </Appear>
    </section>
));
